module.exports = __webpack_public_path__ + "static/media/DM-Positive-Clip-5.52baa3e4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Positive-Clip-5.mp3
// module id = 127
// module chunks = 0